<template>
  <!-- 压力数据 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{
                  item.tenantName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
         
          <a-col :md="8" :sm="12">
            <a-form-item label="压力表编号">
              <a-input v-model="query.piezometerNo" placeholder="请输入压力表编号" allow-clear />
            </a-form-item>
          </a-col>
         
          <a-col :md="8" :sm="12">
            <a-form-item label="采集开始-结束时间">
              <a-range-picker
                v-model="collectionTime"
                :show-time="{ format: 'HH:mm:ss' }"
                format="YYYY-MM-DD HH:mm:ss"
                :placeholder="['采集开始时间', '采集结束时间']"
                @change="collectionOnChange"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-item label="推送开始-结束时间">
              <a-range-picker
                :show-time="{ format: 'HH:mm:ss' }"
                format="YYYY-MM-DD HH:mm:ss"
                :placeholder="['推送开始时间', '推送结束时间']"
                @change="pushOnChange"
                v-model="pushTime"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-item label="安装地址">
              <a-input v-model="query.installAddress" placeholder="请输入安装地址" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <a-button
                type="primary"
                style="margin-left: 8px"
                @click="exportHandle()"
                :loading="exportLoading"
                v-action:export
                >导出</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      :bordered="true"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
    </a-table>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
const columns = [
  {
    title: '压力表编号',
    dataIndex: 'piezometerNo',
  },
 
  {
    title: '压力值',
    dataIndex: 'pressure',
  },
  
  {
    title: '采集时间',
    dataIndex: 'collectTime',
  },
  {
    title: '推送时间',
    dataIndex: 'createTime',
  },
  {
    title: '安装地址',
    dataIndex: 'installAddress',
  },
]

export default {
  mixins: [mixinViewModule],
  name: 'PiezometerList',
  data() {
    return {
      currentId: '',
      queryUrl: '/pipe-network/piezometer/data/history/page',
      deleteUrl: '/pipe-network/piezometer/data/history',
      exportDataUrl: 'pipe-network/piezometer/data/history/export',
      exportFileName: '远传压力表历史数据.xlsx',
      collectionTime: [],
      pushTime: [],
      query: {
        piezometerNo: '',
        installAddress: '',
        tenantId: this.$store.state.user.info.tenantId,
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
    }
  },

  created() {
    this.getAllTenant()
  },
  methods: {
    // 重置
    resetList() {
      this.pushTime = []
      this.collectionTime = []
      this.pagination.current = 1
      this.query = {}
      this.selectedRows = []
      this.queryList()
    },
    pushOnChange(value, dateString) {
      console.log(dateString)
      this.query.startTime = dateString[0]
      this.query.endTime = dateString[1]
    },
    collectionOnChange(value, dateString) {
      this.query.collectBeginTime = dateString[0]
      this.query.collectEndTime = dateString[1]
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
